import { render, staticRenderFns } from "./OfertasTitulo.vue?vue&type=template&id=72c216dd"
import script from "./OfertasTitulo.vue?vue&type=script&lang=js"
export * from "./OfertasTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports